import React from 'react';

import PropTypes from 'prop-types';

import TrackerCard from './trackerCard';

const FleetTracker = ({ hardwareList, tracker }) => {
  const {
    fleetTrackerRateplanTotal,
    additionalServicesTotal,
    addonsTotal,
    vehiclesTotal
  } = tracker;
  const props = {
    title: 'Fleet Tracker',
    hardwareList,
    rateplanTotal: fleetTrackerRateplanTotal,
    ...(additionalServicesTotal && { additionalServicesTotal }),
    addonsTotal,
    vehiclesTotal
  };
  return <TrackerCard {...props} />;
};

FleetTracker.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    fleetTrackerRateplanTotal: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default FleetTracker;
